<div [ngClass]="props.isAutoComplete ? 'autocomplete' : props.isSwitchInput === true ? 'form-check form-switch' : ''"
    *ngIf="!props.propIsHidden">


    <div class="custom-control custom-checkbox custom-checkbox-inter">

        <input class="custom-control-input" [ngClass]="props.readOnly ? 'checkbox-disabled' : ''" type="checkbox"
            value="{{props.id}}" id="{{ props.id }}" formControlName="{{ props.field_Name }}"
            (change)="checkboxEmitter($event)" />

        <label class="custom-control-label" for="{{ props.field_Name }}">{{ props.label }}</label>

    </div>

</div>